import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=47abd3bd&scoped=true&"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ImageThumbnail.vue?vue&type=style&index=0&id=47abd3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abd3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47abd3bd')) {
      api.createRecord('47abd3bd', component.options)
    } else {
      api.reload('47abd3bd', component.options)
    }
    module.hot.accept("./ImageThumbnail.vue?vue&type=template&id=47abd3bd&scoped=true&", function () {
      api.rerender('47abd3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/components/ImageThumbnail.vue"
export default component.exports